import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { storableError } from '../util/errors';
import { verifyEmailSupabase } from '../util/api';
import { fetchCurrentUser } from './user.duck';

// ================ Async Thunk ================ //

export const verifyEmail = createAsyncThunk(
  'emailVerification/verifyEmail',
  ({ tokenHash, type, next }, { dispatch, rejectWithValue }) => {
    return verifyEmailSupabase({ token_hash: tokenHash, type, next })
      .then(() => {
        dispatch(fetchCurrentUser({ enforce: true }));
        return true;
      })
      .catch(e => {
        return rejectWithValue(storableError(e));
      });
  },
  {
    condition: (verificationToken, { getState }) => {
      const state = getState();
      if (state.emailVerification.verificationInProgress) {
        return false;
      }
      return true;
    },
  }
);

// Backward compatible wrapper for the thunk
export const verify = verificationParams => dispatch => {
  return dispatch(verifyEmail(verificationParams));
};

// ================ Slice ================ //

const emailVerificationSlice = createSlice({
  name: 'emailVerification',
  initialState: {
    isVerified: false,
    verificationError: null,
    verificationInProgress: false,
  },
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(verifyEmail.pending, state => {
        state.verificationInProgress = true;
        state.verificationError = null;
      })
      .addCase(verifyEmail.fulfilled, state => {
        state.verificationInProgress = false;
        state.isVerified = true;
      })
      .addCase(verifyEmail.rejected, (state, action) => {
        state.verificationInProgress = false;
        state.verificationError = action.payload;
      });
  },
});

export default emailVerificationSlice.reducer;
